var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_caption",class:_vm.captionHidden ? 'c_caption--hidden' : ''},[_vm._t("default"),_vm._v(" "),(_vm.content)?_c('div',{staticClass:"c_caption__content"},[_c('div',{staticClass:"c_caption__content__content",domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }